import { createTheme } from '@mui/material/styles';

// Horwath HTL Brand Colors
export const brandColors = {
  gold: '#F5A800',
  indigo: '#112337',
  blue: '#204CE5',
  white: '#FFFFFF',
  lightGray: '#F8F9FA',
  mediumGray: '#686E77',
  darkGray: '#32373C',
};

export const theme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: brandColors.gold,
      light: '#FFC344',
      dark: '#C08500',
    },
    secondary: {
      main: brandColors.indigo,
      light: '#2C3E5C',
      dark: '#0A1520',
    },
    info: {
      main: brandColors.blue,
      light: '#5570FF',
      dark: '#1A3DB8',
    },
    background: {
      default: brandColors.lightGray,
      paper: brandColors.white,
    },
    text: {
      primary: brandColors.indigo,
      secondary: brandColors.mediumGray,
    },
  },
  typography: {
    fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif',
    h1: {
      fontWeight: 700,
      fontSize: '2.5rem',
    },
    h2: {
      fontWeight: 600,
      fontSize: '2rem',
    },
    h3: {
      fontWeight: 600,
      fontSize: '1.75rem',
    },
    h4: {
      fontWeight: 600,
      fontSize: '1.5rem',
    },
    h5: {
      fontWeight: 600,
      fontSize: '1.25rem',
    },
    h6: {
      fontWeight: 600,
      fontSize: '1rem',
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          borderRadius: 8,
          fontWeight: 600,
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          boxShadow: '0 2px 12px rgba(0,0,0,0.08)',
          borderRadius: 12,
          border: '1px solid rgba(0,0,0,0.06)',
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundImage: 'none',
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          boxShadow: '0 1px 3px rgba(0,0,0,0.12)',
        },
      },
    },
  },
});
